import { ToggleButton } from "primereact/togglebutton";
import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";


export function LongDivisionSettings() {
    const {settings, setSettings} = useContext(SettingsContext);
    const t = useTranslation();

    function handleRemainderToggle(value) {
        let updatedSettings = {...settings}; 
        updatedSettings.Remainders = value;
        setSettings(updatedSettings);
    }
    return(
        <div className='longDivisionSettingsContainer'>
            <div className='remainderPagesContainer'>
                <label htmlFor='remainders'>{t('settings.remaindersLabel')}</label>
                <ToggleButton onLabel={t('settings.toggleYes')} offLabel={t('settings.toggleNo')} inputId='remainders' className="remainderToggle" checked={settings.Remainders} onChange={(e) => handleRemainderToggle(e.value)}  />
            </div>          
        </div>
    );
}